/**
 * boardingPassItems.ts — Shared item catalogue for the Security Checkpoint game.
 *
 * Imported by both BoardingPassClearance (desktop) and
 * BoardingPassClearanceMobile (mobile CAPTCHA) — no JSX, no logic.
 */

export interface Item {
  id: string;
  label: string;
  /** Local /items/ path (Task 79) or Unsplash CDN for wrong items. emoji = onError fallback. */
  imgUrl: string;
  emoji: string;
  correct: boolean;
}

export const CORRECT_ITEMS: Item[] = [
  {
    id: 'laptop', label: 'Laptop', correct: true, emoji: '💻',
    imgUrl: '/items/laptop.webp',
  },
  {
    id: 'passport', label: 'Passport', correct: true, emoji: '🛂',
    imgUrl: '/items/passport.jpg',
  },
  {
    id: 'headphones', label: 'Headphones', correct: true, emoji: '🎧',
    imgUrl: '/items/headphones.png',
  },
  {
    id: 'phone', label: 'Phone', correct: true, emoji: '📱',
    imgUrl: '/items/phone.jpg',
  },
  {
    id: 'charger', label: 'Charger', correct: true, emoji: '🔌',
    imgUrl: '/items/charger.png',
  },
  {
    id: 'sunglasses', label: 'Sunglasses', correct: true, emoji: '🕶️',
    imgUrl: '/items/sunglasses.jpg',
  },
];

export const WRONG_ITEMS: Item[] = [
  {
    id: 'couch', label: 'Couch', correct: false, emoji: '🛋️',
    imgUrl: 'https://images.unsplash.com/photo-1555041469-a586c61ea9bc?w=240&h=150&fit=crop&auto=format&q=80',
  },
  {
    id: 'tractor', label: 'Tractor', correct: false, emoji: '🚜',
    imgUrl: 'https://images.unsplash.com/photo-1530267981375-f0de937f5f13?w=240&h=150&fit=crop&auto=format&q=80',
  },
  {
    id: 'cow', label: 'Cow', correct: false, emoji: '🐄',
    imgUrl: 'https://images.unsplash.com/photo-1570042225831-d98fa7577f1e?w=240&h=150&fit=crop&auto=format&q=80',
  },
  {
    id: 'television', label: 'Television', correct: false, emoji: '📺',
    imgUrl: 'https://images.unsplash.com/photo-1593359677879-a4bb92f4834?w=240&h=150&fit=crop&auto=format&q=80',
  },
  {
    id: 'bed', label: 'Bed', correct: false, emoji: '🛏️',
    imgUrl: 'https://images.unsplash.com/photo-1540518614846-7eded433c457?w=240&h=150&fit=crop&auto=format&q=80',
  },
  {
    id: 'pizza', label: 'Pizza', correct: false, emoji: '🍕',
    imgUrl: 'https://images.unsplash.com/photo-1565299624946-b28f40a0ae38?w=240&h=150&fit=crop&auto=format&q=80',
  },
];

export const ALL_ITEMS = [...CORRECT_ITEMS, ...WRONG_ITEMS];
